import React, { useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { resetForm } from '../../Redux/slices/addEnquirySlice';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_ADD_UPDATE_EVENTS } from '../../Util/URLConstants';
import { useNavigate } from 'react-router-dom';
import { ROUTE_ALL_ENQUIRIES, SUBMIT, UPDATE } from '../../Util/VMConstants';
import Loader from '../../Components/Loader';
import { formattedDates, isEmpty, syncSubVenueWithBookingFor, toDateKey, YYYYMMDDToDDMMYYYY } from '../../Util/UtilHelper';
import ReusableDialog from '../../Components/ReusableDialog';
import { vmActionButtonSx } from '../../Styles/VMStyles';

function AEButtons({ arrived }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const enquiryData = useSelector((state) => state.addEnquiry);
  const [loading, setLoading] = useState(false);

  // 🔹 Dialog state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const showDialog = (msg) => {
    setDialogMessage(msg);
    setDialogOpen(true);
  };

  function addEventCheckinDatetime(requestObj) {
    requestObj.events = requestObj.events.map((event) => {
      const eventDetails = syncSubVenueWithBookingFor(event.eventDetails);
      const date = toDateKey(eventDetails.event_date);
      const checkIn = eventDetails.check_in;
      const checkOut = eventDetails.check_out;
      const checkInTime = checkIn?.includes("T") ? checkIn.split("T")[1].slice(0, 5) : checkIn;
      const checkOutTime = checkOut?.includes("T") ? checkOut.split("T")[1].slice(0, 5) : checkOut;

      return {
        ...event,
        eventDetails: {
          ...eventDetails,
          check_in: `${date}T${checkInTime}:00`,
          check_out: `${date}T${checkOutTime}:00`,
        },
        serviceDetails: (event.serviceDetails || []).map((service) => ({
          ...(service.service_id != null ? { service_id: service.service_id } : {}),
          service_name: service.service_name,
          service_charge: Number(service.service_charge) || 0,
        })),
      };
      
    });

    return requestObj;
  }

  const handleSubmit = async () => {
    if (!enquiryData || !enquiryData.customer) {
      showDialog("Missing enquiry data!");
      return;
    }

    if (!enquiryData.events || enquiryData.events.length === 0) {
      showDialog("Please add at least one event!");
      return;
    }

    for (let i = 0; i < enquiryData.events.length; i++) {
      const eventDetails = enquiryData.events[i].eventDetails;
      // const accomodationDetails = enquiryData.events[i].accomodationDetails;

      if (isEmpty(eventDetails?.event_name)) { showDialog(`Event ${i + 1}: Please Select Event`); return; }
      if (isEmpty(eventDetails?.event_date)) { showDialog(`Event ${i + 1}: Event Date is Invalid`); return; }
      if (isEmpty(eventDetails?.sub_venue))  { showDialog(`Event ${i + 1}: Sub Venue is Invalid`); return; }
      if (isEmpty(eventDetails?.booking_for) || (Array.isArray(eventDetails.booking_for) && eventDetails.booking_for.length === 0)) {
        showDialog(`Event ${i + 1}: Please Select Booking For`); return;   
      }
      if (isEmpty(eventDetails?.no_of_guests)) { showDialog(`Event ${i + 1}: Please Enter No Of Guests`); return; }
      if (isEmpty(eventDetails?.check_in)) { showDialog(`Event ${i + 1}: Please Enter Check In Time`); return; }
      if (isEmpty(eventDetails?.check_out)) { showDialog(`Event ${i + 1}: Please Enter Check Out Time`); return; }
      if (isEmpty(eventDetails?.rent_charges)) { showDialog(`Event ${i + 1}: Please Enter Rent Charges`); return; }
      // if( (accomodationDetails?.charge_type === 'room' && isEmpty( accomodationDetails?.no_of_rooms) ) ||  ( accomodationDetails?.charge_type === 'person' && isEmpty( accomodationDetails?.persons_data ) ) ){
      //   showDialog("Please add accomodation details.");
      //   return;
      // } 
    }

    const appointmentDates = formattedDates(enquiryData.customer?.appointment_date);
    const eventDates = enquiryData.events.map((e) =>
      toDateKey(e.eventDetails?.event_date)
    );

    for (let date of appointmentDates) {
      if (!eventDates.includes(date)) {
        showDialog(`Event is not created on ${YYYYMMDDToDDMMYYYY(date)}`);
        return;
      }
    }

    const reqBody = {
      enquiry: enquiryData.customer,
      events: enquiryData.events,
    };

    const updatedReqObj = addEventCheckinDatetime(reqBody);

    setLoading(true);

    try {
      const { data } = await axios.post(API_ADD_UPDATE_EVENTS, updatedReqObj, {
        headers: { "Content-Type": "application/json" },
      });

      setLoading(false);

      if (data.status_code === 200) {
        toast.success(data.message); // success can still stay as toast
        navigate("/" + ROUTE_ALL_ENQUIRIES);
      } else {
        showDialog(data.message);
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      showDialog("Something went wrong while submitting!");
    }
  };

  const handleReset = () => {
    dispatch(resetForm());
  };

  return (
    <Box display="flex" justifyContent="center" mt={4} mb={2}>
      <Stack direction="row" spacing={2}>
        {arrived === UPDATE ? null : (
          <Button variant="outlined" color="secondary" onClick={handleReset} sx={vmActionButtonSx}>
            Reset
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
          sx={vmActionButtonSx}
        >
          {/* {arrived === UPDATE ? UPDATE : SUBMIT} */}
          {SUBMIT}
        </Button>
      </Stack>
      {loading && <Loader loading={loading} />}

      {/* 🔹 Reusable Dialog */}
      <ReusableDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        title="Alert"
        message={dialogMessage}
      />
    </Box>
  );
}

export default AEButtons;
